var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgOpenInNew = function SvgOpenInNew(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m17.939 11.469-1.386-1.386a.75.75 0 1 1 1.061-1.061l2.666 2.667c.09.09.153.197.187.311l.001.002q.029.095.032.199v.036a.8.8 0 0 1-.032.199l-.001.002a.74.74 0 0 1-.187.311l-2.666 2.667a.75.75 0 1 1-1.061-1.061l1.386-1.386H8.551a.75.75 0 0 1 0-1.5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.001 5.827a1.77 1.77 0 0 1 1.682-1.826L4.72 4h8.727l.037.001a1.77 1.77 0 0 1 1.683 1.826v3.189a.75.75 0 0 1-1.5 0V5.817l.001-.034a.27.27 0 0 0-.249-.283H4.748a.27.27 0 0 0-.248.282l.001.035v12.799l-.001.034a.27.27 0 0 0 .249.282h8.67a.27.27 0 0 0 .249-.282l-.001-.034v-3.2a.75.75 0 0 1 1.5 0v3.189a1.77 1.77 0 0 1-1.683 1.826l-.037.001H4.72l-.038-.001a1.77 1.77 0 0 1-1.681-1.826z",
    clipRule: "evenodd"
  })));
};
export default SvgOpenInNew;